import React from "react"
import technic from '../img/technic.png'

const Technic = ({image}) => {
    return (
        <img className='technic mt-5' src={technic} alt='technic'/>
    )
}

export default Technic;